import { useMutation } from '@apollo/client';
import React, { Fragment, useEffect } from 'react';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import Header from 'src/components/Header/Header';
import { useAuth } from 'src/hooks/auth';

import Confirmation from './components/Confirmation/Confirmation';
import SEND_BOOSTED_AD_ENQUIRY from './queries/sendBoostedAdEnquiry';

const BoostedAd = () => {
  const [boostedAdSignup, { loading, called }] = useMutation(
    SEND_BOOSTED_AD_ENQUIRY,
  );

  const { getAuthToken } = useAuth();

  useEffect(() => {
    const token = getAuthToken();
    if (Boolean(token) && !called) {
      boostedAdSignup();
    }
  });
  return (
    <Fragment>
      <Header title="Buying a business" />
      {loading ? <CustomLoader /> : <Confirmation />}
    </Fragment>
  );
};

export default BoostedAd;
